import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Component/Header/Header';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Loading from './Component/Loading/Loading';

// Lazy-loaded components
const Carousel = lazy(() => import('./Component/Carousel/Carousel'));
const DesignIntroSection = lazy(() => import('./Component/DesignIntroSection/DesignIntroSection'));
const FeaturedServices = lazy(() => import('./Component/FeaturedServices/FeaturedServices'));
const InteriorPriceEstimator = lazy(() => import('./Component/InteriorPriceEstimator/InteriorPriceEstimator'));
const PROJECTS = lazy(() => import('./Component/PROJECTS/PROJECTS'));
const Words = lazy(() => import('./Component/Words/Words'));
const Footer = lazy(() => import('./Component/Footer/Footer'));
const HiringMain = lazy(() => import('./Component/Hiring/Main'));
const Education = lazy(() => import('./Component/Education/main'));
const Contact = lazy(() => import('./Component/Contact/index'));
const Home = lazy(() => import('./Component/Homepage/Home'));
const About = lazy(() => import('./Component/AboutUs/About-Us'));
const Exparts = lazy(() => import('./Component/OurExpart/Expart'));
const Gallery = lazy(() => import('./Component/Gallery/Gallery'));

// Preloader component that shows for a minimum time
const Preloader = ({ minLoadingTime = 2000 }) => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, minLoadingTime);

    return () => clearTimeout(timer);
  }, [minLoadingTime]);

  return showLoader ? <Loading /> : null;
};

// function Home() {
//   const carouselRef = useRef(null);
//   const designIntroRef = useRef(null);
//   const featuredServicesRef = useRef(null);
//   const priceEstimatorRef = useRef(null);
//   const projectsRef = useRef(null);
//   const wordsRef = useRef(null);
//   const footerRef = useRef(null);

//   const [visibleComponents, setVisibleComponents] = useState({
//     designIntro: false,
//     featuredServices: false,
//     priceEstimator: false,
//     projects: false,
//     words: false,
//     footer: false
//   });

//   useEffect(() => {
//     AOS.init({ duration: 3000, once: true });
//   }, []);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setVisibleComponents((prev) => ({
//               ...prev,
//               [entry.target.dataset.component]: true
//             }));
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       {
//         rootMargin: '100px 0px',
//         threshold: 0.1
//       }
//     );

//     if (designIntroRef.current) observer.observe(designIntroRef.current);
//     if (featuredServicesRef.current) observer.observe(featuredServicesRef.current);
//     if (priceEstimatorRef.current) observer.observe(priceEstimatorRef.current);
//     if (projectsRef.current) observer.observe(projectsRef.current);
//     if (wordsRef.current) observer.observe(wordsRef.current);
//     if (footerRef.current) observer.observe(footerRef.current);

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <>
//       <div className="relative z-10" ref={carouselRef}>
//         <Suspense fallback={<Preloader />}>
//           <Carousel />
//         </Suspense>
//       </div>

//       <div className="relative">
//         <div ref={designIntroRef} data-component="designIntro">
//           <Suspense fallback={null}>
//             {visibleComponents.designIntro && <DesignIntroSection />}
//           </Suspense>
//         </div>

//         <div ref={featuredServicesRef} data-component="featuredServices">
//           <Suspense fallback={null}>
//             {visibleComponents.featuredServices && <FeaturedServices />}
//           </Suspense>
//         </div>

//         <div ref={priceEstimatorRef} data-component="priceEstimator">
//           <Suspense fallback={null}>
//             {visibleComponents.priceEstimator && <InteriorPriceEstimator />}
//           </Suspense>
//         </div>

//         <div ref={projectsRef} data-component="projects">
//           <Suspense fallback={null}>
//             {visibleComponents.projects && <PROJECTS />}
//           </Suspense>
//         </div>

//         <div ref={wordsRef} data-component="words">
//           <Suspense fallback={null}>
//             {visibleComponents.words && <Words />}
//           </Suspense>
//         </div>
        
//         <div>
//           <Footer />
//         </div>
//       </div>
//     </>
//   );
// }

function Interior() {
  const carouselRef = useRef(null);
  const designIntroRef = useRef(null);
  const featuredServicesRef = useRef(null);
  const priceEstimatorRef = useRef(null);
  const projectsRef = useRef(null);
  const wordsRef = useRef(null);
  const footerRef = useRef(null);

  const [visibleComponents, setVisibleComponents] = useState({
    designIntro: false,
    featuredServices: false,
    priceEstimator: false,
    projects: false,
    words: false,
    footer: false
  });

  useEffect(() => {
    AOS.init({ duration: 3000, once: true });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleComponents((prev) => ({
              ...prev,
              [entry.target.dataset.component]: true
            }));
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '100px 0px',
        threshold: 0.1
      }
    );

    if (designIntroRef.current) observer.observe(designIntroRef.current);
    if (featuredServicesRef.current) observer.observe(featuredServicesRef.current);
    if (priceEstimatorRef.current) observer.observe(priceEstimatorRef.current);
    if (projectsRef.current) observer.observe(projectsRef.current);
    if (wordsRef.current) observer.observe(wordsRef.current);
    if (footerRef.current) observer.observe(footerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="relative z-10" ref={carouselRef}>
        <Suspense fallback={<Preloader />}>
          <Carousel />
        </Suspense>
      </div>

      <div className="relative">
        <div ref={designIntroRef} data-component="designIntro">
          <Suspense fallback={null}>
            {visibleComponents.designIntro && <DesignIntroSection />}
          </Suspense>
        </div>

        <div ref={featuredServicesRef} data-component="featuredServices">
          <Suspense fallback={null}>
            {visibleComponents.featuredServices && <FeaturedServices />}
          </Suspense>
        </div>

        <div ref={priceEstimatorRef} data-component="priceEstimator">
          <Suspense fallback={null}>
            {visibleComponents.priceEstimator && <InteriorPriceEstimator />}
          </Suspense>
        </div>

        <div ref={projectsRef} data-component="projects">
          <Suspense fallback={null}>
            {visibleComponents.projects && <PROJECTS />}
          </Suspense>
        </div>

        <div ref={wordsRef} data-component="words">
          <Suspense fallback={null}>
            {visibleComponents.words && <Words />}
          </Suspense>
        </div>
        
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default function App() {
  const [headerSolid, setHeaderSolid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const carouselRef = useRef(null);
  const designIntroRef = useRef(null);

  useEffect(() => {
    // Initialize AOS
    AOS.init({ duration: 1000, once: true });

    // Simulate minimum loading time (2-3 seconds)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // 2.5 seconds

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (carouselRef.current && designIntroRef.current) {
        const carouselBottom = carouselRef.current.offsetTop + carouselRef.current.offsetHeight;
        const scrollPosition = window.scrollY + 100;
        setHeaderSolid(scrollPosition > carouselBottom);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Router>
      <div className="relative font-sansation overflow-x-hidden">
        <div className="fixed top-0 left-0 w-full z-50">
          <Header solid={headerSolid} />
        </div>

        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home osInitialized={true} />} />
            <Route path="/about-us" element={<About osInitialized={true} />} />
            <Route path="/galleries" element={<Gallery osInitialized={true} />} />
            <Route path="/experts" element={<Exparts osInitialized={true} />} />
            <Route path="/interior" element={<Interior />} />
            <Route path="/hiring" element={<HiringMain aosInitialized={true} />} />
            <Route path="/education" element={<Education aosInitialized={true} />} />
            <Route path="/contact-us" element={<Contact />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}